/* Isomorphic implementations of base64 encode/decode */

const nodeBtoa = (b) => Buffer.from(b).toString("base64");
const nodeAtob = (a) => Buffer.from(a, "base64").toString();

export const base64encode = typeof btoa !== "undefined" ? btoa : nodeBtoa;
export const base64decode = typeof atob !== "undefined" ? atob : nodeAtob;
